export default "__VITE_ASSET__32d56bac__"